__turbopack_context__.v({
  "className": "inter_beb947cf-module__mBB1Lq__className",
});
